import React from 'react';
import './IndexCard.css';

const IndexCard = ({ title, sections, onCardClick, size='', shadow=false }) => {
  return (
    <div className={`index-card ${size} ${shadow&&'shadow'}`}>
      <div className="card-title" onClick={onCardClick}>
          {title}
      </div>
      <div className="red-line" />
      {sections.map((section, index) => (
        <div key={index} className="section">
          {section}
        </div>
      ))}
    </div>
  );
};

export default IndexCard;
